import { render, staticRenderFns } from "./AdminAssets.vue?vue&type=template&id=2a5e0f2c"
import script from "./AdminAssets.vue?vue&type=script&lang=js"
export * from "./AdminAssets.vue?vue&type=script&lang=js"
import style0 from "./AdminAssets.vue?vue&type=style&index=0&id=2a5e0f2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports